import React, { useEffect, useState } from "react";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  Box,
  Typography,
  Button,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Snackbar,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useDispatch, useSelector } from "react-redux";
import ButtonTabs from "./widgets/buttontabs";
import {
  setFilters,
  setPage,
  setRowsPerPage,
  GetGameDeposits,
  PostGameDeposits,
} from "../redux/slices/gamedeposits";
import moment from "moment";
import { keyframes } from "@emotion/react";
import * as XLSX from "xlsx";
import autoTable from "jspdf-autotable";
import { Cancel, CheckCircle } from "@mui/icons-material";
import DoneIcon from "@mui/icons-material/Done";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DownloadData from "./widgets/downloaddata";
import { ablyClient, addCreditChannel } from "../lib/socket";
import LazyTable from "./widgets/lazytable";
// Define rotation animation
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const channel = ablyClient.channels.get("gcredit");

const GameDeposits = (read) => {
  const dispatch = useDispatch();
  const {
    page,
    data,
    rowsPerPage,
    totalGameDeposits,
    loading,
    filters,
    approving,
  } = useSelector((state) => state.gameDepostis);
  const isLoading = useSelector((state) => state.gameDepostis.loading);
  const [LoadingIndex, setLoadingIndex] = useState(false);
  const userData = useSelector((state) => state.login.user);
  const fetchGameDeposits = () => {
    dispatch(GetGameDeposits(page, rowsPerPage, filters));
  };

  useEffect(() => {
    fetchGameDeposits();
  }, [page, rowsPerPage, filters]);

  const [selectedFormat, setSelectedFormat] = useState("pdf");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const statusBodyTemplate = (rowData) => {
    let color, icon, statusText;
    const status = (param) =>
      rowData.bl.filter((va, i, m) => m.includes(param));

    if (status(3)?.length) {
      color = "#FFC107";
      statusText = "Pending";
      icon = (
        <>
          <DoneIcon sx={{ color: "white", fontSize: "16px" }} />
        </>
      );
    } else if (status(13)?.length || status(1)?.length) {
      color = "#4CAF50";
      statusText = "Approved";

      icon = (
        <>
          <DoneIcon sx={{ color: "white", fontSize: "16px" }} />
        </>
      );
    }

    return (
      <div className="flex justify-start items-center">
        <Box
          className="mr-2"
          sx={{
            width: 24,
            height: 24,
            borderRadius: "50%",
            backgroundColor: color,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {icon}
        </Box>
        {status(1)?.length
          ? "Deposit"
          : status(3)?.length
          ? "Pending"
          : status(13)?.length
          ? "Deposit"
          : "pending"}
      </div>
    );
  };
  const handleChangePage = (event, newPage) => {
    dispatch(setPage(newPage));
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch(setRowsPerPage(event.target.value, 10));
    dispatch(setPage(0));
  };
  const handleApprove = async (params) => {
    await addCreditChannel("rcradit", params?.user_id, "admin-456", "rcradit");
    const payload = {
      ghid: params?._id,
      uid: params?.user_id,
      aid: userData?.id,
      uname: userData?.name,
      gameid: params?.gameid,
    };

    dispatch(PostGameDeposits(payload));
  };

  useEffect(() => {
    const messageHandler = async (message) => {
      const { senderId, receiverId, text } = message.data;

      if (senderId) {
        // setMessages((prev) => [...prev, { senderId, receiverId, text }]);
        fetchGameDeposits();
      }
    };

    channel.subscribe("gcredit", messageHandler);

    return () => {
      channel.unsubscribe("gcredit", messageHandler);
    };
  }, []);

  const headers = [
    "#",
    "Username",
    "Game Name",
    "Game ID",
    "Current Balance",
    "Deposit Amount",
    "Date",
    "Status",
  ];

  const tableData = data?.map((row, index) => [
    index + 1,
    row?.name,
    row?.game,
    row?.username,
    `$${row?.balance}`,
    `$${row?.deposit}`,
    moment(row?.createdAt).format("L"),
    row?.bl == 3 ? "Pending" : "Deposit",
  ]);

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box
          sx={{ flexGrow: 1, display: "flex", alignItems: "center", gap: 2 }}
        >
          <Typography variant="h5">Game Deposit Requests</Typography>

          <IconButton
            onClick={fetchGameDeposits}
            disabled={isLoading}
            sx={{
              animation: isLoading ? `${rotate} 1s linear infinite` : "none",
              backgroundColor: "#3f51b5",
              color: "white",
              "&:hover": {
                backgroundColor: "#303f9f",
              },
              "&:disabled": {
                backgroundColor: "#e0e0e0",
              },
            }}
          >
            <RefreshIcon />
          </IconButton>
        </Box>
        <DownloadData
          headers={headers || []}
          tableData={tableData || []}
          fileName={"Game-Deposits"}
        />
      </Box>
      <Typography
        sx={{
          color: "#3f51b5",
          mb: 3,
        }}
      >
        Initiate deposit processing by reviewing user-submitted game credit
        funding requests.
      </Typography>
      {/* <Box>
        <ButtonTabs />
      </Box> */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        message="Please select an export format."
        onClose={() => setOpenSnackbar(false)}
      />

      <LazyTable
        data={data}
        page={page}
        rowsPerPage={rowsPerPage}
        totalRecords={totalGameDeposits}
        loading={loading}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        onFilterChange={(filters) => {
          dispatch(setFilters(filters));
        }}
        columns={[
          { field: "name", headerName: "User Name", filter: true },
          {
            field: "game",
            headerName: "Game Name",
            filter: true,
          },
          {
            field: "email",
            headerName: "Email",
            filter: true,
          },
          {
            field: "username",
            headerName: "Game ID",
            filter: true,
            render: (rowData) => (
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="body2">{rowData.username}</Typography>
                <ContentCopyIcon
                  sx={{ cursor: "pointer", fontSize: 18, color: "#666" }}
                  onClick={() =>
                    navigator.clipboard.writeText(rowData.username)
                  }
                />
              </Box>
            ),
          },
          {
            field: "balance",
            headerName: "Wallet Balance",
            filter: true,
          },
          {
            field: "deposit",
            headerName: "Deposit Game Amount",
            filter: true,
          },
          {
            field: "createdAt",
            headerName: "Date",
            filter: true,
            render: (rowData) => moment(rowData?.createdAt).format("L LT"),
          },
          {
            field: "active",
            headerName: "Status",
            filter: true,
            render: statusBodyTemplate,
          },
          {
            field: "actions",
            headerName: "Actions",
            render: (rowData, index) => {
              const status = rowData.bl.filter((va, i, m) => m.includes(3));
              if (status.length > 0) {
                return (
                  <Box display="flex" gap={1}>
                    <Button
                      variant="contained"
                      color="success"
                      size="small"
                      onClick={() => handleApprove(rowData)}
                      loading={rowData._id === approving.ghid}
                      disabled={rowData._id === approving.ghid}
                    >
                      Approve
                    </Button>
                  </Box>
                );
              }
            },
          },
        ]}
      />

      {/* PrimeReact DataTable */}
      {false && (
        <DataTable
          value={data}
          paginator
          rows={10}
          showGridlines
          stripedRows
          tableStyle={{
            minWidth: "50rem",
            border: "1px solid #ddd",
            borderRadius: "8px",
          }}
          className="p-datatable-sm"
          filterDisplay="menu"
        >
          <Column
            field="no"
            header="#"
            body={(rowData, options) => options.rowIndex + 1}
            filter
            filterPlaceholder="Search by #"
          />
          <Column
            field="name"
            header="Username"
            filter
            filterPlaceholder="Search by Username"
          />
          <Column
            field="game"
            header="Game Name"
            filter
            filterPlaceholder="Search by Game Name"
          />
          <Column
            field="email"
            header="Email"
            filter
            filterPlaceholder="Search by Email"
          />
          <Column
            field="username"
            header="Game ID"
            filter
            filterPlaceholder="Search by Game ID"
            body={(rowData) => (
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="body2">{rowData.username}</Typography>
                <ContentCopyIcon
                  sx={{ cursor: "pointer", fontSize: 18, color: "#666" }}
                  onClick={() =>
                    navigator.clipboard.writeText(rowData.username)
                  }
                />
              </Box>
            )}
          />
          <Column
            field="balance"
            header="Wallet Balance"
            filter
            filterPlaceholder="Search by Balance"
            body={(rowData) => `$${rowData?.balance}`}
          />
          {/* <Column
          field="balance"
          header="Before Game Balance"
          filter
          filterPlaceholder="Search by Balance"
          body={(rowData) => `$${rowData?.balance}`}
        /> */}
          <Column
            field="deposit"
            header="Deposit Game Amount"
            filter
            filterPlaceholder="Search by Balance"
            body={(rowData) => `$${rowData?.deposit}`}
          />
          {/* <Column
          field="deposit"
          header="After Game Deposit"
          filter
          filterPlaceholder="Search by Balance"
          body={(rowData) => `$${rowData?.deposit}`}
        /> */}
          <Column
            field="createdAt"
            header="Date"
            filter
            body={(rowData) => moment(rowData?.createdAt).format("L LT")}
            filterPlaceholder="Search by Date"
          />
          <Column
            header="Status"
            body={statusBodyTemplate}
            style={{ width: "120px" }}
          />
          {read?.read?.access != "read" && (
            <Column
              body={(rowData, index) => {
                const status = rowData.bl.filter((va, i, m) => m.includes(3));
                if (status.length > 0) {
                  return (
                    <Box display="flex" gap={1}>
                      <Button
                        variant="contained"
                        color="success"
                        size="small"
                        onClick={() => handleApprove(rowData, index)}
                        disabled={LoadingIndex === index ? true : false}
                      >
                        {LoadingIndex === index ? (
                          <CircularProgress size={20} color="inherit" />
                        ) : (
                          "Approve"
                        )}
                      </Button>
                    </Box>
                  );
                }
              }}
              header="Actions"
            />
          )}
        </DataTable>
      )}
    </>
  );
};

export default GameDeposits;
